module.exports = __webpack_public_path__ + "img/symbol_12.a3ee71fb.png";